// extracted by mini-css-extract-plugin
export default {"wrapper":"MyStudentsProlongations_wrapper__2x8Gn","container":"MyStudentsProlongations_container__BlaiG","fixedCol":"MyStudentsProlongations_fixedCol__Y-V+s"};